<div class="header">
  <h1>{{ statusMessage }}</h1>
  <mat-chip-list *ngIf="statusMessage">
    <mat-chip color="primary" selected class="count-chip">{{
      leadArray.length || 0
    }}</mat-chip>
  </mat-chip-list>
</div>
<div class="table-container">
  <div class="content">
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter leads</mat-label>
        <input
          matInput
          (keyup)="filterLeads($event)"
          #input
          placeholder="ex. John Doe"
        />
      </mat-form-field>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      class="table"
      matSort
      fixedLayout="true"
    >
      <ng-container matColumnDef="company_Code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Code</th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.company_Code }}
        </td>
      </ng-container>
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.customer || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="leadTypeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead Type</th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.leadTypeName || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastContacted">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Last Contacted
        </th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.lastContacted || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="leadSubSourceName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>SubSource</th>
        <td mat-cell *matCellDef="let lead">{{ lead.leadSubSourceName }}</td>
      </ng-container>
      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
        <td mat-cell *matCellDef="let lead">{{ lead.createdDate | date }}</td>
      </ng-container>
      <ng-container matColumnDef="updatedBy">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated By</th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.updatedBy || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="updatedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated Date</th>
        <td mat-cell *matCellDef="let lead">
          {{
            lead.updatedDate ? (lead.updatedDate | date : "shortDate") : "n/a"
          }}
        </td>
      </ng-container>
      <ng-container matColumnDef="jobAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Property Address
        </th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.jobAddress || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="estimator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Estimator</th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.estimator || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="dispositionName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Disposition</th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.dispositionName || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="subDispositionName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          SubDisposition
        </th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.subDispositionName || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="dispositionNotes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Disposition Notes
        </th>
        <td mat-cell *matCellDef="let lead">
          {{ lead.dispositionNotes || "n/a" }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr class="mat-row" *matNoDataRow [ngStyle]="{ 'text-align': 'center' }">
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No matching leads found
        </td>
      </tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="goToLead(row)"
      ></tr>
    </table>

    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>

    <mat-paginator
      [pageSize]="100"
      [pageSizeOptions]="[10, 50, 100, 150, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
